import { render, staticRenderFns } from "./Center_Ap.vue?vue&type=template&id=f15e1272&scoped=true"
import script from "./Center_Ap.vue?vue&type=script&lang=js"
export * from "./Center_Ap.vue?vue&type=script&lang=js"
import style0 from "./Center_Ap.vue?vue&type=style&index=0&id=f15e1272&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15e1272",
  null
  
)

export default component.exports